module.exports = __webpack_public_path__ + "img/icon_flag-b.3b9c8d12.svg";